import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchSavedEquipment, addSavedEquipment, deleteSavedEquipment } from './api';
import type { EquipmentKind, WeightClass } from '../../shared/types/app';

export const SAVED_EQUIPMENT_KEY = ['saved-equipment'] as const;

export function useSavedEquipment() {
  return useQuery({
    queryKey: SAVED_EQUIPMENT_KEY,
    queryFn: fetchSavedEquipment,
  });
}

export function useAddSavedEquipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (item: {
      label: string;
      equipmentKind: EquipmentKind;
      equipmentDesc?: string;
      weightClass: WeightClass;
      make: string;
      model: string;
      estimatedWeight?: number | null;
      photoUrl?: string | null;
    }) => addSavedEquipment(item),
    onSuccess: () => qc.invalidateQueries({ queryKey: SAVED_EQUIPMENT_KEY }),
  });
}

export function useDeleteSavedEquipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteSavedEquipment(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: SAVED_EQUIPMENT_KEY }),
  });
}
